var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"scrolling-text-container",attrs:{"aria-label":"Scrolling text"}},[_c('p',{staticClass:"scrolling-text",style:({ '--duration': _setup.duration + 's' })},[_vm._v(" "+_vm._s(_setup.$t(_vm.text))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }